import { AppRef } from 'common/modules/ReactShared';
import { useEffect, useState } from 'react';
import { useHintVisibility } from '../useHintVisibility';

const SHAKE_TIMEOUT = 6000;

type tFlashCardHint = [
  hintVisible: boolean,
  updateLastInteractionTime: (timeout?: number) => void,
  shaking: boolean
];

const useFlashcardHint = (shouldAppear = true): tFlashCardHint => {
  const { createTimeout, dropTimeout } = AppRef.current.utils.useTimeout();
  const [hintVisible, updateLastInteractionTime] = useHintVisibility(shouldAppear);
  const [shaking, setShaking] = useState(false);
  useEffect(() => {
    if (!hintVisible) {
      setShaking(false);
      return undefined;
    }

    const timer = createTimeout(() => setShaking(true), SHAKE_TIMEOUT);

    return () => {
      dropTimeout(timer);
    };
  }, [hintVisible, createTimeout, dropTimeout]);

  return [hintVisible, updateLastInteractionTime, shaking];
};

export { useFlashcardHint };
export type { tFlashCardHint };
